(function() {
  'use strict';

  var root = document.querySelector('.fpc-addons');
  if (!root) return;

  var productId = root.dataset.productId;
  var priceWrap = document.querySelector('.fpc-price[data-product-id="' + productId + '"]');
  var priceDisplay = priceWrap ? priceWrap.querySelector('[data-fpc-price-display]') : null;
  var checkboxes = root.querySelectorAll('[data-addon-checkbox]');
  var productForm = document.querySelector('product-form form, form[action*="/cart/add"]');
  var submitBtn = productForm ? productForm.querySelector('button[type="submit"], [name="add"]') : null;

  if (!priceWrap || !priceDisplay) return;

  var basePrice = parseInt(priceWrap.dataset.basePrice, 10) || 0;

  function formatPrice(cents) {
    var pounds = Math.floor(cents / 100);
    var pence = (cents % 100).toString().padStart(2, '0');
    return '<span class="price__prefix">£</span>' + pounds + '<sup class="price__suffix">.' + pence + '</sup>';
  }

  function getCheckedAddonsTotal() {
    var total = 0;
    checkboxes.forEach(function(cb) {
      if (cb.checked) {
        total += parseInt(cb.dataset.variantPrice, 10) || 0;
      }
    });
    return total;
  }

  function updatePriceDisplay() {
    var total = basePrice + getCheckedAddonsTotal();
    priceDisplay.innerHTML = formatPrice(total);
  }

  function rebindBaseFromVariant() {
    // Be Yours stores variants JSON inside its variant-radios / variant-selects custom element
    var variantSwitcher = document.querySelector('variant-radios, variant-selects');
    if (!variantSwitcher) return;

    var variantsScript = variantSwitcher.querySelector('script[type="application/json"]');
    if (!variantsScript) return;

    // Find the currently-selected variant by reading the option values
    var checkedRadios = variantSwitcher.querySelectorAll('input[type="radio"]:checked');
    if (checkedRadios.length === 0) return;

    var selectedOptions = [];
    checkedRadios.forEach(function(r) {
      selectedOptions.push(r.value);
    });

    try {
      var variants = JSON.parse(variantsScript.textContent);
      var match = variants.find(function(v) {
        // v.options is an array like ['Large']; compare with selected options array
        if (!v.options || v.options.length !== selectedOptions.length) return false;
        return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
      });
      if (match && typeof match.price === 'number') {
        basePrice = match.price;
        priceWrap.dataset.basePrice = basePrice;
      }
    } catch (e) {
      console.error('FPC variant parse error:', e);
    }
    updatePriceDisplay();
  }

  // Listen for variant changes — Be Yours dispatches 'change' on the custom element when option clicked
  var variantSwitcher = document.querySelector('variant-radios, variant-selects');
  if (variantSwitcher) {
    variantSwitcher.addEventListener('change', function() {
      setTimeout(rebindBaseFromVariant, 50);
    });
  }

  // Bind addon checkboxes
  checkboxes.forEach(function(cb) {
    cb.addEventListener('change', updatePriceDisplay);
  });

  // Bind variant change
  if (productForm) {
    productForm.addEventListener('change', function(e) {
      if (!e.target) return;
      if (e.target.name === 'id' || (e.target.closest && e.target.closest('variant-radios, fieldset.product-form__input'))) {
        setTimeout(rebindBaseFromVariant, 50);
      }
    });
  }

  // Intercept form submit to add main product + ticked addons in one cart request
  if (productForm && submitBtn) {
    productForm.addEventListener('submit', function(e) {
      var checkedAddons = [];
      checkboxes.forEach(function(cb) {
        if (cb.checked) {
          checkedAddons.push({
            id: parseInt(cb.dataset.variantId, 10),
            quantity: 1
          });
        }
      });

      if (checkedAddons.length === 0) return;

      e.preventDefault();
      e.stopPropagation();

      var formData = new FormData(productForm);
      var mainItem = {
        id: parseInt(formData.get('id'), 10),
        quantity: parseInt(formData.get('quantity') || '1', 10),
        properties: {}
      };

      formData.forEach(function(value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value) {
          mainItem.properties[match[1]] = value;
        }
      });

var items = checkedAddons.concat([mainItem]);

      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function(cartItems) {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        var cartDrawer = document.querySelector('cart-drawer');
        var cartNotification = document.querySelector('cart-notification');
        var target = cartDrawer || cartNotification;

        if (target) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          if (typeof target.open === 'function') {
            target.open(submitBtn);
          } else if (typeof target.renderContents === 'function') {
            target.renderContents(cart);
          } else {
            var cartLink = document.querySelector('a[href="/cart"], .header__icon--cart');
            if (cartLink) cartLink.click();
          }

          var cartCount = document.querySelectorAll('.cart-count, [data-cart-count], .cart-link__bubble');
          cartCount.forEach(function(el) {
            el.textContent = cart.item_count;
          });
        } else {
          window.location.href = '/cart';
        }

        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
      })
      .catch(function(err) {
        console.error('FPC addon cart error:', err);
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
        alert('Sorry, something went wrong adding items to your cart. Please try again.');
      });
    }, true);
  }

  updatePriceDisplay();
})();